import React from "react";
import { Link } from "react-router-dom";
import { LockOutlined } from "@ant-design/icons";
import "../styles/components/popover.scss";

const PopOverItem = props => {
  let jsx = (
    <Link to={props.link} onClick={props.onClick}>
      {props.title}
    </Link>
  );
  if (props.link === "") {
    jsx = (
      <button
        onClick={() => {
          props.func();
          props.onClick();
        }}
        className={props.disable ? "disable" : ""}
      >
        {props.disable && <LockOutlined />}
        {props.title}
      </button>
    );
  }
  return (
    <div className={`popover-item ${props.primary ? "primary" : ""}`}>
      {jsx}
    </div>
  );
};

export default PopOverItem;
